import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { SvgIconProps } from '@mui/material'
import {
  PeopleAlt,
  CardGiftcard,
  // CardGiftcardOutlined,
  Home,
  Assessment,
  Casino,
  // SupervisedUserCircle,
  // Grain,
} from '@mui/icons-material'
import routes from '@/routes'

import { SidebarId } from '@/enums/sidebar-id.enum'
import { authSelector } from '@/state/auth/slices/index.slices'
import { ADMIN_VIEW } from '@/constants/brand'

export type SidebarLinkType = {
  id: SidebarId
  route: string
  labelText: string
  labelIcon?: React.ReactElement<SvgIconProps>
  order?: number
  links?: SidebarLinkType[]
  visible?: boolean
  title?: string
}

/**
 * useSidebarLinks
 * @description This hooks allows build the sidebar links based on the product and module.
 * @returns links
 */
const useSidebarLinks = () => {
  const { t } = useTranslation()

  const { brand } = useSelector(authSelector)

  const { REACT_APP_STAGE: env } = process.env

  const links: SidebarLinkType[] = [
    {
      id: SidebarId.HOME,
      route: '/',
      labelText: t('pages.home'),
      labelIcon: <Home />,
      visible: true,
      title: t('sidebar.general'),
      order: 0,
    },
    {
      id: SidebarId.REPORTS,
      route: `${routes.reports.INDEX}`,
      labelText: t('pages.reports'),
      labelIcon: <Assessment />,
      visible: true,
      order: 1,
      links: [
        {
          id: SidebarId.REPORTS,
          route: `${routes.reports.INDEX}`,
          labelText: t('labels.overview'),
          visible: true,
          order: 1,
        },
        {
          id: SidebarId.REPORTS_BALANCE,
          route: `${routes.reports.BALANCE}`,
          labelText: t('reports.balanceReport'),
          visible: true,
          order: 2,
        },
      ],
    },
    // {
    //   id: SidebarId.SPORT_RO_CALCULATOR,
    //   route: `${routes.sportsROCalculator.INDEX}`,
    //   labelText: t('pages.sportsROCalculator'),
    //   labelIcon: <Casino />,
    //   visible: env !== 'prod',
    //   order: 2,
    // },
    {
      id: SidebarId.BONUS_ENGINE,
      route: `${routes.wallets.INDEX}`,
      labelText: t('pages.bonusEngine'),
      labelIcon: <CardGiftcard />,
      visible: brand.siteId !== ADMIN_VIEW, // Not visible to ADMIN_VIEW
      order: 3,
      links: [
        {
          id: SidebarId.BONUS_WALLETS,
          route: `${routes.wallets.INDEX}`,
          labelText: t('pages.wallet'),
          visible: brand.siteId !== ADMIN_VIEW,
          order: 1,
        },
        {
          id: SidebarId.BONUS_ENGINE,
          route: `${routes.bonus.INDEX}`,
          labelText: t('pages.bonusProgram'),
          visible: brand.siteId !== ADMIN_VIEW,
          order: 2,
        },
      ],
    },
    {
      id: SidebarId.USERS,
      route: routes.users.INDEX,
      labelText: t('pages.user'),
      labelIcon: <PeopleAlt />,
      visible: true,
      title: t('sidebar.management'),
      order: 4,
    },
  ]

  return {
    links,
  }
}

export default useSidebarLinks
